<template>
    <v-container fluid no-gutters class="mx-0 px-0">
        <v-row>
            <v-col cols="12">
                <v-chip-group
                    v-model="option"
                    column
                    mandatory
                >
                    <v-chip
                        v-for="(item, index) in ['Μέσοι Όροι', 'Σύνολο']"
                        :key="index"
                        filter
                        filter-icon="mdi-basketball-hoop"
                        active-class="custom-teal selected-chip"
                        color="white"
                        large
                        mandatory
                        class="text-h5 font-weight-bold"
                    >
                        {{ item }}
                    </v-chip>
                </v-chip-group>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-for="(stat, index) in stats"
                :key="index"
                cols="4"
                md="2"
                class="mx-0 px-5"
                style="text-transform: capitalize;"
                align="center"
            >
                <v-card v-if="!$vuetify.breakpoint.mobile" class="elevation-1 py-16" dark>
                    <div class="circle-top white--text text-h4 secondary-font font-weight-bold">
                        {{ option === 0 && matchesPlayed > 0 ? (stat.total / matchesPlayed).toFixed(1) : stat.total }}
                    </div>
                    <div class="circle-bottom text-h5 font-weight-bold">
                        {{ stat.value === 'blockedShots' ? 'blocks' : stat.value }}
                    </div>
                </v-card>
                <div v-else class="circle-border" style="background: #232323;">
                    <div class="secondary-font text-h6">
                        {{ option === 0 ? (stat.total / matchesPlayed).toFixed(1) : stat.total }}
                    </div>
                    <div class="custom-teal-text">
                        {{ getText(stat.value) }}
                    </div>
                </div>
            </v-col>
        </v-row>
        <players-stats :players="players" :option="option" />
    </v-container>
</template>

<script>
    import PlayersStats from '@/components/PlayersStats'
    export default {
        components: { PlayersStats },
        props: {
            players: {
                type: Array,
                default: null
            },
            matchesPlayed: {
                type: Number,
                default: 1
            },
            type: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                option: 0,
                stats: [
                    { key: 'points', value: 'PTS', total: 0 },
                    { key: 'rebounds', value: 'RBD', total: 0 },
                    { key: 'assists', value: 'AST', total: 0 },
                    { key: 'steals', value: 'STL', total: 0 },
                    { key: 'turnovers', value: 'TO', total: 0 },
                    { key: 'blockedShots', value: 'BLK', total: 0 }
                ]
            }
        },
        watch: {
            players: {
                handler() {
                    this.getTotalTeam()
                },
                deep: true
            }
        },
        created() {
            this.getTotalTeam()
        },
        methods: {
            getTotalTeam() {
                this.stats.forEach(stat => {
                    stat.total = 0
                    this.players.forEach(player => {
                        player.stats.forEach(match => {
                            stat.total += match[stat.key]
                        })
                    })
                })
            },
            getText(key) {
                if (key === 'blockedShots') {
                    return 'blocks'
                } else if (key === 'rebounds') {
                    return 'reb.'
                } else if (key === 'turnovers') {
                    return 'turn.'
                } else {
                    return key
                }
            }
        }
    }
</script>

<style scoped>
.circle-border {
    border-radius: 50%;
    border: 5px solid teal;
    width: 90px;
    height: 90px;
    padding: 15px;
    background: #fff;
    text-align: center;
}

.text-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.text-h4 {
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
}

.stat-label {
    color: #757578 !important;
    font-size: 1.2rem;
}

.top-arc {
    border-width: 2px;
    border-radius: 10px 5% / 20px 25em 30px 35em;
    border-color: teal;
}

.v-chip::before {
    background-color: white !important;
}

.selected-chip {
    color: white;
}

/* Top-only semicircle above the desktop stat card */
.circle-top {
    position: relative;
    overflow: visible; /* allow pseudo-element to show outside */

    /* add top padding so the semicircle doesn't overlap content */

    /* padding-top: 40px; */
}

.circle-top::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0; /* aligned with top edge of the card */
    transform: translate(-50%, -50%); /* center horizontally and move up by half height */
    width: 130px;
    height: 80px;
    border-radius: 50%;
    border: 5px solid teal;
    background: transparent; /* keep interior transparent to show card color */
    box-sizing: border-box;

    /* show only the top half */
    clip-path: inset(0 0 60% 0);
    z-index: 2;
}

@media (max-width: 960px) {
    .circle-top {
        padding-top: 28px;
    }

    .circle-top::before {
        width: 88px;
        height: 88px;
        transform: translate(-50%, -50%);
        border-width: 4px;
    }
}

/* Bottom-only semicircle below the desktop stat label */
.circle-bottom {
    position: relative;
    overflow: visible;
}

.circle-bottom::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0; /* aligned with bottom edge of the label area */
    transform: translate(-50%, 50%); /* center horizontally and push down by half height */
    width: 130px;
    height: 80px;
    border-radius: 50%;
    border: 5px solid teal;
    background: transparent;
    box-sizing: border-box;

    /* show only the bottom half */
    clip-path: inset(60% 0 0 0);
    z-index: 2;
}

@media (max-width: 960px) {
    .circle-bottom {
        padding-bottom: 28px;
    }

    .circle-bottom::after {
        width: 88px;
        height: 88px;
        transform: translate(-50%, 50%);
        border-width: 4px;
    }
}
</style>
